import 'waypoints/lib/jquery.waypoints.min.js';

export default () => {

  $(document).ready(function() {
    $('.gl-skillbar').waypoint(function(direction) {
        $('.gl-skillbar[data-percent]').each(function () {
            var skillbarWrapper = $(this);
            var progress = $(this).find('span.skill-bar-percent');
            var percentage = Math.ceil($(this).attr('data-percent'));
                $({countNum: 0}).animate({countNum: percentage}, {
                  duration: 3000,
                  step: function() {
                    // What todo on every count
                  var pct = '';
                  if(percentage == 0){
                    pct = Math.floor(this.countNum) + '%';
                  }else{
                    pct = Math.floor(this.countNum+1) + '%';
                  }
                  progress.text(pct) && skillbarWrapper.find('.gl-skillbar-bar').css('width',pct);
                  }
                });
              })
            this.destroy()
        }, {
        offset: 'bottom-in-view'
    });
  });

};



/** WEBPACK FOOTER **
 ** ./assets/src/js/skillbar/skillbarInit.js
 **/